export interface IEditorValue {
    blocks: [{
        data: any,
        depth: number,
        entityRanges: any[],
        inlineStyleRanges: any[],
        key: string,
        text: string,
        type: string
    }],
    entityMap: any,
}